<template>
  <div class="wall-page">
    <OptionCard
      title="Buitenwand"
      v-if="buitenwandEnabled"
      @updateStatus="updateWallOutsideOn" 
      :status="buitenWandAan"
    >
      <CategorySelector  
        categoryTitle="Type wand"
        optionTitle="Kleur"
        :categorys="categoriesOutside"
        :selectedCategory="selectedCategoryOutside"
        :selectedColor="selectedWallColorOutside.color"
        :status="selectedWall == null ? true : wallOutsideOn"
        show-third-section
        third-section-title="Isolatie"
        :extra-option-is-turned-on="wallIsolatieStatus"
        extra-option-off-graphic="Wandisolatie_lang_UIT.svg"
        extra-option-on-graphic="Wandisolatie_lang_AAN.svg"
        @changeCategory="changeCategoryOutside"
        @changeColor="updateWallColorOutside"
        @changeExtraOption="updateWallIsolatie"
      />
    </OptionCard>

    <OptionCard
      title="Binnenwand" 
      @updateStatus="updateWallInsideOn" 
      :status="binnenWandAan"
    >
      <CategorySelector  
        categoryTitle="Type wand"
        optionTitle="Kleur"
        :categorys="categoriesInside"
        :selectedCategory="selectedCategoryInside"
        :selectedColor="selectedWallColorInside.color"
        :status="selectedWall == null ? true : wallInsideOn"
        show-third-section
        third-section-title="Isolatie"
        :extra-option-is-turned-on="wallIsolatieStatus"
        extra-option-off-graphic="Wandisolatie_lang_UIT.svg"
        extra-option-on-graphic="Wandisolatie_lang_AAN.svg"
        @changeCategory="changeCategoryInside"
        @changeColor="updateWallColorInside"
        @changeExtraOption="updateWallIsolatie"
      />
      <!-- selectedWall == null ? wallIsolatieStatus : selectedWall.settings.heeftIsolatie -->
    </OptionCard>

    <h3 class="isolatie-section-title">WANDISOLATIE</h3>

    <div class="isolatie-section-description">
      <mdicon name="floor-plan" size="58" />
      <span class="isolatie-section-description-text">In de plattegrond- en/of 3D-weergave kunt u de wandisolatie per wand aan- of uitzetten.</span>
    </div>

    <div class="isolatie-section-buttons">
    <!-- {{ extraOptionIsTurnedOn }} -->
      <button 
        class="extra-option-toggle"
        @click="updateWallIsolatie(true)"
      >
        <img 
          :src="`${previewsServer}/textures/ui/Wandisolatie_active.png`" 
          class="togglegraphic"
          height="50"
          width="50" 
        >
        <span class="extra-option-label">Aan</span>
      </button>
      <button 
        class="extra-option-toggle"
        @click="updateWallIsolatie(false)"
      >
        <img 
          :src="`${previewsServer}/textures/ui/Wandisolatie_inactive.png`" 
          class="togglegraphic"
          height="50"
          width="50" 
        >
        <span class="extra-option-label">Uit</span>
      </button>
      <div class="infobox" v-if="uiSettings[0]?.isolatieInfobox">
        <button 
          class="card-button-specs" 
          @mouseover="specsBtnMouseOver" 
          @mouseleave="specsBtnMouseLeave"
          @click.stop="enableAndHoldSpecs()"
        >
          <div class="card-question-mark" style="pointer-events: none;">?</div>
          <h3 class="card-button-specs-text">
            Meer info
          </h3>
        </button>
      </div>
    </div>

    <RouterView />
  </div>

<Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcover"
        @click="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
            <button 
              class="modalclosebutton" 
              @mouseover="specsCloseBtnMouseOver" 
              @mouseleave="specsCloseBtnMouseLeave"
              @click="specsVisible = false"
            >
              <Transition name="closebtn">
                <div 
                  v-show="hasGlowingCloseBtn"
                  class="absolutepos glowingclose"
                />
              </Transition>
              <div>
                ×
              </div>
            </button>
          <!-- <div class="greyheader"> 
            {{ data.infobox.header }}
          </div> -->
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${infoboxes.find(info => info.id === uiSettings[0]?.isolatieInfobox)?.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>

</template>

<script>
  import CategorySelector from '@/components/inputs/CategorySelector.vue'
  import OptionCard from '@/components/layout/OptionCard.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: "AddWalls",

    components: {
      CategorySelector,
      OptionCard
    },

    data () {
      return {
        wallTextures: [],
        wallColors: {buiten: [], binnen: []},
        buitenWandAan: false,
        binnenWandAan: false,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        uisettings: this.$store.state.cms.menuUISettings,
        specsVisible: false,
        hasGlowingInfoBtn: false,
        hasGlowingCloseBtn: false
      }
    },

    methods: {
      updateWallColorInside(color) {
        this.$store.dispatch('updateWallTextureInside', color)
      },

      updateWallColorOutside(color) {
        this.$store.dispatch('updateWallTextureOutside', color)
      },

      updateWallIsolatie(isActive/*object*/) {
        // console.log('triggered method updateWallIsolatie with value',isActive)
        this.$store.dispatch('updateWallIsolatieStatus', isActive)
        if (this.selectedWall !== null) {
          this.selectIsolatieType();
        }
      },
      selectIsolatieType() {
        const isolatieType = this.getIsolatieTypeDefault; //this.getIsolatieTypes[0];
        // console.log('selectIsolatieType',isolatieType);
        this.$store.dispatch('updateWallIsolatieType', isolatieType)
      },

      changeCategoryInside (category) {
        this.$store.dispatch('updateWallCategoryInside', category)
      },

      changeCategoryOutside (category) {
        this.$store.dispatch('updateWallCategoryOutside', category)
      },

      updateWallOutsideOn (status) {
        this.$store.dispatch('updateWallOutsideOn', status)
      },

      updateWallInsideOn (status) {
        this.$store.dispatch('updateWallInsideOn', status)
      },

      updateAvaibleWallColors (newData) {

        // if wall hover leave, check if there is a wall taht is still selected
        if(newData == undefined || newData == null) {
          if(this.selectedWall !== null) {
            this.updateAvaibleWallColors(this.selectedWall)
            return
          }
        }

        if(newData !== undefined && newData !== null) {
          const isTopgevel = newData.isTopgevel
          const isTussenMuur = newData.settings.tussenMuur

          const buitenSelector = isTopgevel ? (isTussenMuur ? "topgevelLinks" : "topgevelBuiten") : (isTussenMuur ? "tussenWandLinks" : "wandBuiten")
          const binnenSelector = isTopgevel ? (isTussenMuur ? "topgevelRechts" : "topgevelBinnen") : (isTussenMuur ? "tussenWandRechts" : "wandBinnen")
          
          // console.log(this.availableWallFinishes, buitenSelector, binnenSelector)

          this.wallColors.buiten = this.availableWallFinishes[buitenSelector]
          this.wallColors.binnen = this.availableWallFinishes[binnenSelector]
          
        } else {
          //show all available 

          this.wallColors.buiten = [] 
          this.wallColors.binnen = []
          this.wallTextures.forEach((texture) => {

            const plankType = this.getPlankTypes.find((plankType) => plankType.id === texture.plankType) 

            const isInBuiten = this.getWallFinishes.wandBuiten.includes(texture.id) ||
            this.getWallFinishes.tussenWandLinks.includes(texture.id) ||
            this.getWallFinishes.topgevelBuiten.includes(texture.id) ||
            this.getWallFinishes.topgevelLinks.includes(texture.id)

            const isInBinnen = this.getWallFinishes.wandBinnen.includes(texture.id) ||
            this.getWallFinishes.tussenWandRechts.includes(texture.id) ||
            this.getWallFinishes.topgevelBinnen.includes(texture.id) ||
            this.getWallFinishes.topgevelRechts.includes(texture.id)

            //buiten of links
            if(this.wallColors.buiten.find((plankTypeBuiten) => plankTypeBuiten.id === plankType.id)) {
              if(isInBuiten) {
                const newPlankType = this.wallColors.buiten.find((plankTypeBuiten) => plankTypeBuiten.id === plankType.id)
                newPlankType.colors.push({
                  name: this.getMenuColors.filter(color => color.id === texture.color)[0].name,
                  url: texture.url,
                  previewURL: texture.url,
                  hex: this.getMenuColors.filter(color => color.id === texture.color)[0].hexCode,
                  id: this.getMenuColors.filter(color => color.id === texture.color)[0].id,
                  plankType: plankType.id,
                  open: this.getMenuColors.filter(color => color.id === texture.color)[0].open,
                  houtsoort: texture.houtsoort
                })
              }
            } else {
              if(isInBuiten) {
                const newPlankType = {
                  id: plankType.id,
                  type: plankType.name,
                  typeImage: plankType.image,
                  connection: plankType.connection,
                  infobox: plankType.infobox,
                  infoboxIsOnline: plankType.infoboxIsOnline,
                  colors: []
                }
                newPlankType.colors.push({
                  name: this.getMenuColors.filter(color => color.id === texture.color)[0].name,
                  url: texture.url,
                  previewURL: texture.url,
                  hex: this.getMenuColors.filter(color => color.id === texture.color)[0].hexCode,
                  id: this.getMenuColors.filter(color => color.id === texture.color)[0].id,
                  plankType: plankType.id,
                  open: this.getMenuColors.filter(color => color.id === texture.color)[0].open,
                  houtsoort: texture.houtsoort
                })
                this.wallColors.buiten.push(newPlankType)
              }
            }

            //binnen of rechts
            if(this.wallColors.binnen.find((plankTypeBinnen) => plankTypeBinnen.id === plankType.id)) {
              if(isInBinnen) {
                const newPlankType = this.wallColors.binnen.find((plankTypeBinnen) => plankTypeBinnen.id === plankType.id)
                newPlankType.colors.push({
                  name: this.getMenuColors.filter(color => color.id === texture.color)[0].name,
                  url: texture.url,
                  previewURL: texture.url,
                  hex: this.getMenuColors.filter(color => color.id === texture.color)[0].hexCode,
                  id: this.getMenuColors.filter(color => color.id === texture.color)[0].id,
                  plankType: plankType.id,
                  open: this.getMenuColors.filter(color => color.id === texture.color)[0].open,
                  houtsoort: texture.houtsoort
                })
              }
            } else {
              if(isInBinnen) {
                const newPlankType = {
                  id: plankType.id,
                  type: plankType.name,
                  typeImage: plankType.image,
                  connection: plankType.connection,
                  infobox: plankType.infobox,
                  infoboxIsOnline: plankType.infoboxIsOnline,
                  colors: []
                }
                newPlankType.colors.push({
                  name: this.getMenuColors.filter(color => color.id === texture.color)[0].name,
                  url: texture.url,
                  previewURL: texture.url,
                  hex: this.getMenuColors.filter(color => color.id === texture.color)[0].hexCode,
                  id: this.getMenuColors.filter(color => color.id === texture.color)[0].id,
                  plankType: plankType.id,
                  open: this.getMenuColors.filter(color => color.id === texture.color)[0].open,
                  houtsoort: texture.houtsoort
                })
                this.wallColors.binnen.push(newPlankType)
              }
            }

          })
          
        }

        if(!this.wallColors.buiten.find((category) => category.type === this.selectedWallColorOutside.type)) {
          this.changeCategoryOutside(this.wallColors.buiten[0])
          this.updateWallColorOutside(this.wallColors.buiten[0].colors[0])
        }

        if(!this.wallColors.binnen.find((category) => category.type === this.selectedWallColorInside.type)) {
          this.changeCategoryInside(this.wallColors.binnen[0])
          this.updateWallColorInside(this.wallColors.binnen[0].colors[0])
        }
      },
      async getUISettings() {
        await this.$store.dispatch('getMenuUISettings')
      },
      specsBtnMouseOver() {
        this.hasGlowingInfoBtn = true;
      },
      specsBtnMouseLeave(){
        this.hasGlowingInfoBtn = false;
      },
      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
      }
    },

    computed: {
      ...mapGetters({
        selectedWallColorInside: 'getSelectedWallColorInside',
        selectedWallColorOutside: 'getSelectedWallColorOutside',
        wallInsideOn: 'getWallInsideOn',
        wallOutsideOn: 'getWallOutsideOn',
        wallIsolatieStatus: 'getWallIsolatieStatus',
        getTextures: 'getTextures',
        getWallFinishes: 'getWallFinishes',
        selectedWall: 'getSelectedWall',
        selectedWallObject: 'getSelectedWallObject',
        hoveringWall: 'getHoveringWall',
        getPlankTypes: 'getPlankTypes',
        getIsolatieTypes: 'getIsolatieTypes',
        getIsolatieTypeDefault: 'getIsolatieTypeDefault',
        isolatieTypeFromSelectedWall: 'getIsolatieTypeFromSelectedWall', // usage not yet implemented
        getMenuColors: 'getMenuColors',
        availableWallFinishes: 'getAvailableWallFinishes',
        config: 'getConfig',
        uiSettings: 'getMenuUISettings',
        infoboxes: 'getInfoboxes'
      }),

      buitenwandEnabled () {
        const verandaEnabled = this.config.afmetingen.veranda?.enabled
        const shouldBeHidden =
          this.selectedWall != null &&
          this.selectedWallObject &&
          !this.selectedWallObject.alignsXAxis &&
          !this.selectedWallObject.alignedRotation &&
          verandaEnabled
        return !shouldBeHidden
      },

      selectedCategoryInside () {
        return this.wallColors.binnen.find((category) => category.type === this.selectedWallColorInside.type)
      },

      selectedCategoryOutside () {
        return this.wallColors.buiten.find((category) => category.type === this.selectedWallColorOutside.type)
      },

      categoriesOutside () {
        if (this.selectedWall && this.selectedWallObject?.isBorstwering) {
          return this.wallColors.buiten.filter((category) => !category.colors.some((color) => color.open))
        } else {
          return this.wallColors.buiten
        }
      },

      categoriesInside () {
        if (this.selectedWall && this.selectedWallObject?.isBorstwering) {
          return this.wallColors.binnen.filter((category) => !category.colors.some((color) => color.open))
        } else {
          return this.wallColors.binnen
        }
      },
    },

    created () {
      this.wallTextures = this.getTextures.filter((texture) => texture.textureType === "62cd857a7c20bc17b85af2cd")
      this.$store.dispatch('getWallColors')
      this.updateAvaibleWallColors()
      this.getUISettings()
    },

    mounted() {
      this.wallSettingsFetcher = setInterval(() => {
        const wallSettings = this.selectedWall?.settings
        if (wallSettings !== null && wallSettings !== undefined) {
          this.binnenWandAan = wallSettings.binnenMuur
          this.buitenWandAan = wallSettings.buitenMuur
        } else {
          this.binnenWandAan = true
          this.buitenWandAan = true
        }
      }, 100)
    },

    unmounted() {
      clearInterval(this.wallSettingsFetcher)
    },

    watch: {
      selectedWall: {
        immediate: false,
        handler (newData) {
          // console.log('newData',newData)
          this.updateAvaibleWallColors(newData)
        }
      },

      hoveringWall: {
        immediate: false,
        handler (newData) {
          this.updateAvaibleWallColors(newData)
          // console.log(newData)
        }
      },
    }


  }
</script>

<style lang="scss" scoped>

.wall-page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 15px;
  min-width: 100%;

  &-preview {
    padding-bottom: 25px;
  }
}

.isolatie-section {


  &-title {
    background-color: $c-background-1;
    font-size: 1.2rem;
    margin: 0px;
    font-size: 19px;
    color: $c-primary;
    font-family: "Oswald", sans-serif;
    text-transform: uppercase;
    height: 48px;
    width: 100%;
    line-height: 48px;
    border-radius: $radius-m;
  }

  &-description {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 8px;
    
    &-text {
      text-align: left;
      font-size: 20px;
      font-weight: 400
    }
  }

  &-color {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-content: flex-start;
  }

  &-buttons {
    display: flex;
    width: 80%;
    margin: auto;
  }
}

.extra-option-toggle {
  // border-style: none; 
  border: 3px solid white;
  border-radius: 2rem;
  background-color: transparent;//black;
  position: relative;
}

.extra-option-toggle {
  display: flex;
  align-items:center;
  flex-direction: row;
  gap: 8px;
  cursor: pointer;
}

.extra-option-label {
  font-size: 20px;
  text-transform: uppercase;
}

.infobox {
  display: flex;
  justify-content: flex-end;
  flex:1;
  align-items: center;
}

.card {
  &-button-specs {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    // position: absolute;
    margin-top: 4px;
    height: 23px;
    right: 0;
    padding: 3px;
    border-radius: $radius-l;
    border-style: none;
    background-color: $c-secondary; // babc16
    color: white; //$c-secondary-text;

    &-text {
      font-size: 0.8rem;
      padding: 0px 8px;
      padding-right: 16px;
      font-family: 'Source Sans 3', sans-serif;
    }
  }

  &-question-mark {
    // padding: 5px 10px;
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}


#fullcover {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  // top: 10%;
  left: 50%;
  // width: 30rem;
  // margin-left: -15rem;
  // height: 80vh;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}
// .greyheader {
//   color: $c-secondary;
//   background-color: $c-primary; 
//   border-radius: 5px; 
//   margin: 0px 10px 10px 10px; 
//   font-size: x-large;
//   text-align: center; 
// }

.imagescroller {
  // max-height: calc(85% - 1px); // a trick to force a scroll area to appear despite fixed position
  max-height: calc(98%); // minus size of modaltopcontainer
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  // margin-left: auto;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  // padding: 0px 10px 0px 10px;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

</style>